import { MDSRowItemAppearance } from "@/mds";

export const APPEARANCES_WITHOUT_SEPARATOR: readonly MDSRowItemAppearance[] = [
  MDSRowItemAppearance.ActiveSuggestion,
  MDSRowItemAppearance.AudioRecordingRecording,
  MDSRowItemAppearance.AudioRecordingUploading,
  MDSRowItemAppearance.AudioRecordingProcessing,
  MDSRowItemAppearance.AudioRecordingUploadingFailed,
  MDSRowItemAppearance.AudioRecordingProcessingFailed,
];

export const APPEARANCES_WITHOUT_SEPARATOR_SET = new Set(APPEARANCES_WITHOUT_SEPARATOR);
